var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBookingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9961 55.8695L32.6726 54.0852L31.3344 51.8547L30.8883 40.7023C31.602 39.9886 33.8622 40.9997 34.9031 41.5945V24.643C37.4012 21.0742 40.4049 23.156 41.5945 24.643V36.2414C43.022 35.5277 45.7581 36.5388 46.9476 37.1336V32.6727V4.12266C47.3045 1.98141 45.0146 1.1487 43.825 1H10.368C7.86983 1.35687 7.2453 3.23047 7.2453 4.12266V30.4422H14.3828C14.3828 34.7247 10.2193 36.6875 8.13749 37.1336L7.2453 40.7023C13.669 45.6986 11.4088 52.8956 9.47577 55.8695H29.9961Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94065 8.37175L10.258 42.4993C10.261 42.8221 10.3449 43.1385 10.4866 43.4285C11.7052 45.922 11.927 48.347 11.7677 50.2179C11.6474 51.6308 12.6616 53.139 14.0792 53.1768L29.3348 53.5842C30.4599 53.6143 31.3882 52.7104 31.3882 51.5849V42.4472C31.3882 42.2216 31.6487 41.9033 31.8496 41.8004C32.5423 41.4454 34.6252 40.1294 34.6252 39.351V25.114C34.6252 24.8812 34.6625 24.6487 34.7549 24.435C35.3263 23.114 36.1596 22.5998 36.7043 22.4592C36.9034 22.4078 37.1101 22.3807 37.3095 22.3311C39.637 21.7522 40.9027 23.3687 41.3443 24.4873C41.4154 24.6673 41.4399 24.8604 41.4399 25.0539V34.218C41.4399 34.8766 41.9738 35.4105 42.6324 35.4105C43.2911 35.4105 43.825 34.8766 43.825 34.218V8.35315C43.825 7.24858 42.9296 6.35315 41.825 6.35315H11.9406C10.8287 6.35315 9.93031 7.25996 9.94065 8.37175Z",
    fill: "#C1DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2724 63V60.3263C40.3812 60.6048 38.2645 60.6605 36.9277 58.6553L31.4132 51.971V40.4408C32.1373 39.9951 33.7861 39.6386 34.5882 41.7776V24.7328C34.9224 23.6745 36.2593 21.6915 38.933 22.2262C39.7128 22.4491 41.2724 23.2623 41.2724 24.7328V36.096C42.5536 35.539 45.3164 35.0599 46.1185 37.6C47.3439 36.8758 50.0622 36.0626 51.1317 38.6026C52.6356 37.8785 55.7772 37.2323 56.3119 40.4408V54.8118C56.3676 56.3158 55.8106 59.5242 53.1369 60.3263V62.4987",
    stroke: "url(#paint0_linear_2852_241)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51714 29.746V4.01177C7.29433 3.06484 7.48372 1.13755 10.0237 1.00387H44.4475C45.283 0.948168 46.8872 1.47177 46.6198 4.01177V32.4197",
    stroke: "url(#paint1_linear_2852_241)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8658,
    y: 10.5275,
    width: 10.029,
    height: 9.69476,
    stroke: "url(#paint2_linear_2852_241)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5303 25.0671H31.4132",
    stroke: "#86A6CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0421 29.9132H31.2461",
    stroke: "#86A6CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7079 35.4276H31.5803",
    stroke: "#86A6CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3632 40.1067H26.5671H27.0685",
    stroke: "#86A6CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0764 55.4803C29.6753 55.3466 16.318 55.4245 9.68949 55.4803C11.3605 52.4166 13.1653 45.0863 7.0158 40.2736L8.18554 36.5973C10.0237 36.3745 13.8337 34.7592 14.3684 30.0802H5.17764L1 38.7697V56.4829",
    stroke: "url(#paint3_linear_2852_241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2852_241",
    x1: 43.8644,
    y1: 22.1364,
    x2: 43.8644,
    y2: 63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E77D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E77D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2852_241",
    x1: 27.0488,
    y1: 1,
    x2: 27.0488,
    y2: 32.4197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E77D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E77D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2852_241",
    x1: 18.8803,
    y1: 10.0275,
    x2: 18.8803,
    y2: 20.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E77D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E77D0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2852_241",
    x1: 15.5382,
    y1: 30.0802,
    x2: 15.5382,
    y2: 56.4829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E77D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E77D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBookingIcon);
export default __webpack_public_path__ + "static/media/viewBookingIcon.baa417b2bb9c13486c57c32a76bf0996.svg";
export { ForwardRef as ReactComponent };